import {
  FC,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { useBooleanValue } from '@edikk-edikk/hooks';
import { Subject } from 'rxjs';
import { useIntl } from 'react-intl';
import { AdvertListFilterItem } from '@edikk-edikk/country-frontend';
import { Detail } from '#advertList/components/filter/detail/Detail';
import { FilterContext } from '#advertList/components/filter/contexts/FilterContext';
import { FilterContextType } from '#advertList/components/filter/contexts/FilterContextType';
import { Controls } from '#advertList/components/filter/controls/Controls';
import { useAdvertListContext } from '#advertList/hooks';
import advertListFilterContentCss from '#srcCssModules/advert/list-filter/advert-list-filter-content.module.scss';

const Filter: FC = () => {
  const { filterData } = useAdvertListContext();
  const [isVisible, open, hide] = useBooleanValue(false);
  const onChangeSubject = useMemo(() => new Subject<string>(), []);
  const intl = useIntl();
  const filterItemList: AdvertListFilterItem[] = useMemo(
    () => {
      if (filterData.areaList) {
        return filterData.areaList.map((area) => AdvertListFilterItem.initByArea(intl, area));
      }
      if (filterData.cityList) {
        return filterData.cityList.map((city) => AdvertListFilterItem.initByCity(intl, city));
      }
      if (filterData.categoryList) {
        return filterData.categoryList.map((category) => AdvertListFilterItem.initByCategory(intl, category));
      }
      return [];
    },
    [filterData.areaList, filterData.categoryList, filterData.cityList, intl],
  );
  const refDetail = useRef<HTMLDivElement>(null);

  const openDetail = useCallback(() => {
    open();

    const maxHeight = document.querySelector(`.${advertListFilterContentCss.advertListFilterContent}`).scrollHeight;
    refDetail.current.style.maxHeight = `${maxHeight}px`;
    refDetail.current.style.marginTop = '0.5rem';
  }, [open]);

  const hideDetail = useCallback(() => {
    hide();
    refDetail.current.style.maxHeight = '0px';
    refDetail.current.style.marginTop = '0';
  }, [hide]);

  if (filterItemList.length === 0) {
    return null;
  }

  const filterContextValue: FilterContextType = {
    isVisible,
    openDetail,
    hideDetail,
    onChangeSubject,
    filterItemList,
    refDetail,
  };

  return (
    <FilterContext value={filterContextValue}>
      <div>
        <Controls />
        <Detail />
      </div>
    </FilterContext>
  );
};

export { Filter };
